import React, { useState } from "react";
import moment from "moment";
import { 
    Title, 
    Close, 
    Row, 
    Legend, 
    Info, 
    FieldTitle, 
    ItemName, 
    DetailsOrDownload, 
    NotExist, 
    ProductDetailsContainer, 
    FirstCol, 
    SecondCol, 
    ThirdCol, 
    ItemDetailOrDownloadContainer,
    Hr,
    ContainerButton,
    DialogHeader
} from "./styles";
import close from "../../assets/icons/close.svg";
import { useSelector } from "react-redux";
import { IModalProducts } from "./interfaces";
import Dropzone from "../Dropzone";
import Modal from "react-bootstrap/Modal"
import { Button } from "../Button/styles";
import { IGroupProduct } from "../../views/ecommerce/group/interfaces";
import { getGroups } from "../../hooks/getGroups";
import { getDetails } from "../../hooks/getDetails";
import { getProductImage } from "../../hooks/getImageProduct";
import { changeImageProduct } from "../../hooks/changeImageProduct";
import { InfoGroupProduct} from "../InfoGroupProduct";
import InfoDetailsProduct from "../InfoDetailsProduct";
import InfoImagesProduct from "../InfoImagesProduct";
import { IProductImage } from "../../views/ecommerce/products/interfaces";

const ModalProductDetail = ({
    product,
    title
}: IModalProducts) => {
    const data = {
        nameProduct: product.nameProduct!,
        active: product.active!,
        amount: product.amount,
        updated_at: moment(product.updated_at).format("DD/MM/YYYY"),
        created_at: moment(product.created_at).format("DD/MM/YYYY"),
        description: product.description!,
        details: product.details!
    }
    const [isGroupShow, setIsGroupShow] = useState(false);
    const [smShow, setSmShow] = useState(false);
    const [isDetailsShow, setIsDetailsShow] = useState(false);
    const [isImgShow, setIsImgShow] = useState(false);
    const [groupData, setGroupData] = useState<Array<IGroupProduct>>([]);
    const [productDetails, setProductDetails] = useState([]);
    const [imgProduct, setImgProduct] = useState<Array<IProductImage>>([]);
    const [selectedImageId, setSelectedImageId] = useState("")
    const [newImage, setNewImage] = useState<File>(new File([""], ""))
    const login = useSelector((state: {login: any}) => state.login);

    const handlerClose = () => {
        setSmShow(false)
        setIsDetailsShow(false)
        setIsImgShow(false)
    }

    const handlerGroups = (): void => {
        if(isGroupShow) {
            setIsGroupShow(false)
        }

        else {
            getGroups(login, setGroupData)
            setIsGroupShow(true)
        }
    }

    const handlerDetails = (): void => {
        if(isDetailsShow) {
            setIsDetailsShow(false)
        }

        else {
            getDetails(login, setProductDetails)
            setIsDetailsShow(true)
        }
    }

    const handlerImages = (): void => {
        if(isImgShow) {
            setIsImgShow(false)
        } 
        
        else if(!isImgShow){
            getProductImage(product.id, setImgProduct)
            setIsImgShow(true)
        }
    }

    const handlerChangeImage = async (): Promise<void> => {
        const {isError} = await changeImageProduct(product.id, selectedImageId, newImage)
        
        if(!isError) {
            setIsImgShow(true)
        }
    }

    return (        
        <div className="modal fade" id="details-product"  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <Modal
                size="sm"
                show={smShow}
                onHide={() => handlerClose()}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title>Mudar imagem</Modal.Title>
                    <Close onClick={() => {
                        handlerClose()
                    }}>
                        <img src={close} alt="fechar"/>
                    </Close>
                </Modal.Header>
                <Modal.Body>
                    <Dropzone onFileUploaded={setNewImage} type="image/png" />
                    <ContainerButton>
                        <Button
                            type="submit" 
                            onClick={() => handlerChangeImage()}
                        >
                            Mudar
                        </Button>
                    </ContainerButton>
                </Modal.Body>
            </Modal>
            <div className="modal-dialog modal-dialog-centered modal-actions">
                <div className="modal-content">
                    <DialogHeader className="d-flex justify-content-between">
                        <div>
                            <Title>{title}</Title>
                            <Info>{`Última atualização ${data.updated_at}`}</Info>
                        </div>
                        <Close 
                            data-dismiss="modal" 
                            aria-label="Close" 
                            onClick={ () => handlerClose() }
                        >
                            <img src={close} alt="fechar"/>
                        </Close>
                    </DialogHeader>
                    <div>
                        <FieldTitle>Dados Principais</FieldTitle>
                        <Row>
                            <FirstCol >
                                <Legend>Nome</Legend>
                                <Info>{data.nameProduct}</Info>
                            </FirstCol>
                            <SecondCol>
                                <Legend>Descrição</Legend>
                                <Info>{data.description}</Info>
                            </SecondCol>
                            <ThirdCol>
                                <Legend>Data de criação</Legend>
                                <Info>{data.created_at}</Info>
                            </ThirdCol>
                        </Row>
                        <Row>
                            <FirstCol >
                                <Legend>Valor do produto</Legend>
                                <Info>R$ {(parseInt(data.amount!) / 100).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Info>
                            </FirstCol>
                            
                            <ThirdCol/>
                        </Row>
                    </div>
                    
                    <div className="modal-body">
                        <Hr/>
                        <FieldTitle >Grupo</FieldTitle>
                        <ItemDetailOrDownloadContainer>
                        <ItemName>Grupos de produtos</ItemName>
                        <DetailsOrDownload  onClick={() => handlerGroups()}>
                            Ver detalhes
                        </DetailsOrDownload>
                        </ItemDetailOrDownloadContainer>
                        <ProductDetailsContainer isOpen={isGroupShow}>
                            <InfoGroupProduct group={groupData} />
                        </ProductDetailsContainer>
                        <Hr />
                        <FieldTitle>Detalhes</FieldTitle>
                        <ItemDetailOrDownloadContainer>
                        <ItemName>Variações</ItemName>
                        <DetailsOrDownload  onClick={() => handlerDetails() }>
                            Ver detalhes
                        </DetailsOrDownload>
                        </ItemDetailOrDownloadContainer>
                        <ProductDetailsContainer isOpen={isDetailsShow}>
                            <InfoDetailsProduct listDetails={productDetails} />
                        </ProductDetailsContainer>
                        <Hr />
                        <FieldTitle>Imagens</FieldTitle>
                        <ItemDetailOrDownloadContainer>
                        <ItemName>Imagens</ItemName>
                        <DetailsOrDownload  onClick={() => handlerImages()}>
                            Ver detalhes
                        </DetailsOrDownload>
                        </ItemDetailOrDownloadContainer>
                        <ProductDetailsContainer isOpen={isImgShow}>
                            <Row>
                                <InfoImagesProduct images={imgProduct} setSelectedImgId={setSelectedImageId}/>
                            </Row>
                        </ProductDetailsContainer>
                        <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default ModalProductDetail